import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { type SealProXMachine } from "@packsize/schemas/machines";

import { getSealProXMachines } from "@/api/machines/seal-pro-x-api-v2";

import { type UseMachinesQueryOptions } from "../types";

import { SEAL_PRO_X_MACHINES_QUERY_KEY } from "./query-keys";

const REFETCH_INTERVAL = 15 * 1000;

export const getSealProXMachinesQuery = <TData = SealProXMachine[], TError = Error>(
	options?: UseMachinesQueryOptions<TData, TError>,
) => ({
	queryKey: SEAL_PRO_X_MACHINES_QUERY_KEY,
	queryFn: getSealProXMachines,
	refetchInterval: REFETCH_INTERVAL,
	staleTime: 10 * 1000,
	...options,
});

export const useSealProXMachines = (
	options?: UseMachinesQueryOptions<SealProXMachine[], Error>,
): UseQueryResult<SealProXMachine[], Error> => {
	return useQuery<SealProXMachine[], Error>(getSealProXMachinesQuery(options));
};
